import type { Editor } from 'slate';
import type { SlateBlock } from '@atlas/renderer';
import matchBlockNodes, { type BlockMatchOptions } from '@atlas/tool/box/slate/matchBlockNodes';
export type { BlockMatch } from '@atlas/tool/box/slate/matchBlockNodes';

export default function matchTopBlockNodes<T extends SlateBlock>(editor: Editor, options?: TopBlockMatchOptions<T>) {
    return matchBlockNodes<T>(editor, { ...options, mode: 'highest' });
}

// #region Types

export type TopBlockMatchOptions<T extends SlateBlock> = Omit<BlockMatchOptions<T>, 'mode'>;

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('matchTopBlockNodes', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
